export function loadIntlPolyfill() {
	const head = document.getElementsByTagName('head')[0];
	const node = document.createElement('script');
	node.type = 'text/javascript';
	node.src = window.chash ? `/${window.chash}/intl-polyfill.js` : '/intl-polyfill.js';
	node.async = false;
	head.appendChild(node);
	return new Promise((resolve, reject) => {
		node.onload = () => {
			resolve(null);
		};
		node.onerror = () => {
			reject();
		};
	});
}
